import { numberWithCommas } from "utils/time-utils";
import clickAudio from 'assets/images/audio/click.mp3';

const txcbFunction = {
    animateValue: (obj: HTMLElement, start: number, end: number, duration: number, callback: () => void) => {
        let startTimestamp: number | null = null;
        let i = 0;
        const step = (timestamp: number) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            i += 1;
            if (i % 3 === 0) {
                obj.innerHTML = numberWithCommas(Math.floor(progress * (end - start) + start));
            }
            if (progress < 1 && duration !== -1) {
                window.requestAnimationFrame(step);
            } else {
                callback();
            }
        };
        window.requestAnimationFrame(step);
    },
    effectChipBet: (htmlString: string, listChip: any[], placeEl: HTMLElement, chipValue: number, scale: number) => {
        let chipActiveEl = listChip.find((chipEl: HTMLButtonElement) => {
            return Number(chipEl.getAttribute('datatype')) === chipValue;
        });
        chipActiveEl = chipActiveEl.getBoundingClientRect();
        const coordinatesEl = placeEl.getBoundingClientRect();

        const cloneChip = document.createElement('div');
        cloneChip.innerHTML = htmlString;
        cloneChip.classList.add('chipEmbed');
        cloneChip.style.left = `${chipActiveEl.left - coordinatesEl.left}px`;
        cloneChip.style.top = `${chipActiveEl.top - coordinatesEl.top}px`;
        cloneChip.style.width = chipActiveEl.width + 'px';
        cloneChip.style.height = chipActiveEl.width + 'px';
        placeEl.append(cloneChip);

        setTimeout(() => {
            cloneChip.style.transform = `scale(${scale})`;
            cloneChip.style.left = `${coordinatesEl.width / 2 - chipActiveEl.width * scale}px`;
            cloneChip.style.top = `${coordinatesEl.height / 2 - chipActiveEl.width * scale}px`;
        }, 10);

        setTimeout(() => {
            cloneChip.remove();
        }, 290);
    },
    collideCircle: (
        circle1: {
            x: number;
            y: number;
            radius: number;
        },
        circle2: {
            x: number;
            y: number;
            radius: number;
        }
    ) => {
        const distanceX = circle1.x - circle2.x;
        const distanceY = circle1.y - circle2.y;
        const radiiSum = circle1.radius + circle2.radius;
        console.log(distanceX, distanceY, radiiSum);
        return distanceX * distanceX + distanceY * distanceY <= radiiSum * radiiSum;
    },
    playClick: (el: HTMLAudioElement) => {
        el = new Audio(clickAudio);
        el.pause();
        el.currentTime = 0;
        el.play();
    },
};

export const chatSuggestTXCB = [
    'Tài mạnh tay',
    'Xỉu mạnh tay',
    'Gãy cầu rồi',
    'Húp trọn!!',
    'Bú xỉu tiếp',
    'Nay đen vãi',
    'Ai kéo em vào bờ với',
    'Cầu đẹp zô thôi!!',
    'Anh đi rút tiền đây^^',
    'Đánh tài ra xỉu:(',
    'Yêu ad vl',
];

export default txcbFunction;
